import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Lottie } from "src/app/shared/constant/lottie";

@Component({
    selector: "web-coupon-congratulations",
    templateUrl: "./coupon-congratulations.component.html",
    styleUrls: ["./coupon-congratulations.component.scss"],
})
export class CouponCongratulationsComponent {
    constructor(
        private dialog: MatDialog,
        public lottie: Lottie,

        private dialogRef: MatDialogRef<CouponCongratulationsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    submit() {
        this.dialogRef.close({ data: true, details: this.data });
    }

    closeDialog() {
        this.dialogRef.close({ data: true, details: this.data });
    }
}
